import { NgModule } from '@angular/core'; 
import { Routes, RouterModule } from '@angular/router';
import { SitioPublicoComponent } from './sitio-publico.component';
/*
import { TopBarComponent } from './componentes/top-bar/top-bar.component';
import { FooterComponent } from './componentes/footer/footer.component';
*/
import { InicioComponent } from './componentes/inicio/inicio.component';
import { IngresoComponent } from './componentes/ingreso/ingreso.component';
import { NuevoUsrComponent } from './componentes/nuevo-usr/nuevo-usr.component';
import { NuevaEmpComponent } from './componentes/nueva-emp/nueva-emp.component';
import { PedirAccesoEmpComponent } from './componentes/pedir-acc-emp/pedir-acc-emp.component';
import { CambioPwdComponent } from './componentes/cambio-pwd/cambio-pwd.component';
import { TerminosUsoComponent } from './componentes/terminos-uso/terminos-uso.component';

const routes: Routes = [
  /*
    { path: '', component: InicioComponent },
  */
    { 
      path: '', 
      component: SitioPublicoComponent,
      children: [
        { 
          path: '', 
          pathMatch: 'full',
          redirectTo: 'inicio' 
        },
        { 
          path: 'inicio', 
          component: InicioComponent 
        },
        { 
          path: 'ingreso', 
          component: IngresoComponent 
        },
        { 
          path: 'nuevoUsr', 
          component: NuevoUsrComponent 
        },
        { 
          path: 'nuevaEmp', 
          component: NuevaEmpComponent 
        },
        { 
          path: 'pedirAccesoEmp', 
          component: PedirAccesoEmpComponent 
        },
        { 
          path: 'cambioPwd', 
          component: CambioPwdComponent 
        },
        { 
          path: 'terminos', 
          component: TerminosUsoComponent
        }
      ]
     }
  ];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SitioPublicoRuteoModule { }
